/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  KillswitchHistoryAction,
  KillswitchHistoryAction$inboundSchema,
} from "./killswitchhistoryaction.js";
import {
  KillswitchSchedule,
  KillswitchSchedule$inboundSchema,
} from "./killswitchschedule.js";
import {
  KillswitchScope,
  KillswitchScope$inboundSchema,
} from "./killswitchscope.js";
import {
  KillswitchStatus,
  KillswitchStatus$inboundSchema,
} from "./killswitchstatus.js";

export type KillswitchHistoryEvent = {
  actorDisplayName?: string | undefined;
  actorUserId?: string | undefined;
  changedAt: Date;
  externalNote: string;
  internalNote: string;
  schedule: KillswitchSchedule;
  scope: KillswitchScope;
  sequence: number;
  version: number;
  action: KillswitchHistoryAction;
  status: KillswitchStatus;
};

/** @internal */
export const KillswitchHistoryEvent$inboundSchema: z.ZodMiniType<
  KillswitchHistoryEvent,
  unknown
> = z.pipe(
  z.object({
    actor_display_name: z.optional(z.string()),
    actor_user_id: z.optional(z.string()),
    changed_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    external_note: z.string(),
    internal_note: z.string(),
    schedule: KillswitchSchedule$inboundSchema,
    scope: KillswitchScope$inboundSchema,
    sequence: z.int(),
    version: z.int(),
    action: KillswitchHistoryAction$inboundSchema,
    status: KillswitchStatus$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "actor_display_name": "actorDisplayName",
      "actor_user_id": "actorUserId",
      "changed_at": "changedAt",
      "external_note": "externalNote",
      "internal_note": "internalNote",
    });
  }),
);

export function killswitchHistoryEventFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchHistoryEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchHistoryEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchHistoryEvent' from JSON`,
  );
}
